import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory()({
  targets: {
    actionButton: HTMLButtonElement,
  },
  values: {
    actionHref: String,
  },
}) {
  action_button(event: MouseEvent) {
    event.preventDefault();

    const el = document.querySelector("meta[name='csrf-token']");
    const token = el?.getAttribute("content") || "";

    fetch(`${this.actionHrefValue}`, {
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
      method: "POST",
    }).catch((error) => console.error("Error:", error));
  }
}
